/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: unified
 */
import React, { useEffect } from 'react';
import { useRoute } from '@react-navigation/native';
import { useScreenLoad } from '../../shared/ui/hooks-screen/useScreenLoad';
import { ensureTicketFonts } from '../../shared/ticket/ensureTicketFonts';
import { ReportsErrorBoundary } from './ReportsErrorBoundary';
import { ReportsScreenView } from './ReportsScreenView';
import { useReportsScreen } from './useReportsScreen';

export const ReportsScreen = () => {
  useEffect(() => {
    ensureTicketFonts();
  }, []);

  const vm = useReportsScreen();
  const route = useRoute();

  const { refreshing, onRefresh } = useScreenLoad(
    route.name,
    async (opts) => { await vm.loadFn(opts); },
    // Los reportes consultan data que muta en otras pantallas (ventas, gastos,
    // caja) — recarga al enfocar con ventana de 60 s para no martillar las
    // queries pesadas en cada cambio de tab.
    { minFocusIntervalMs: 60_000 }
  );

  const vmWithRefresh = { ...vm, refreshing, onRefresh };

  return (
    <ReportsErrorBoundary>
      <ReportsScreenView vm={vmWithRefresh} />
    </ReportsErrorBoundary>
  );
};
